import React, { useState,createContext,useContext } from "react";


 const DetectContext = createContext();

 const DetectProvider = ({ children }) => {
  const [model, setModel] = useState();
 
  return (
    <DetectContext.Provider
      value={{
        model, 
        setModel
      }}
    >
      {children}
    </DetectContext.Provider>
  );
};

function useDetect() {
  const context = useContext(DetectContext);
  
  if (!context) {
    throw new Error("useDetect must be used within a DetectProvider");
  }
  return context;
}

export { DetectProvider, useDetect };
